import { version as c } from "react";
import { isError as u } from "./chunk809.js";
import { captureException as o } from "./chunk810.js";
function i(t) {
  const e = t.match(/^([^.]+)/);
  return e !== null && parseInt(e[0]) >= 17;
}
function f(t, e) {
  const r = /* @__PURE__ */ new WeakSet();
  function n(a, s) {
    if (!r.has(a)) {
      if (a.cause)
        return r.add(a), n(a.cause, s);
      a.cause = s;
    }
  }
  n(t, e);
}
function x(t, { componentStack: e }, r) {
  if (i(c) && u(t) && e) {
    const n = new Error(t.message);
    n.name = `React ErrorBoundary ${t.name}`, n.stack = e, f(t, n);
  }
  return o(t, {
    ...r,
    captureContext: {
      contexts: { react: { componentStack: e } }
    }
  });
}
export {
  x as captureReactException,
  i as isAtLeastReact17,
  f as setCause
};
